export var DefaultHosts;
(function (DefaultHosts) {
    DefaultHosts["APP"] = "mlbatbat://";
    DefaultHosts["WEB"] = "https://www.mlb.com";
})(DefaultHosts || (DefaultHosts = {}));
export const getHost = ({ host, isApp }) => {
    return host || (isApp ? DefaultHosts.APP : DefaultHosts.WEB);
};
